function ObjectSourceObjPage() {
	return null
}

export default ObjectSourceObjPage
